import { render, staticRenderFns } from "./ImotSelect.vue?vue&type=template&id=8350f820"
import script from "./ImotSelect.vue?vue&type=script&lang=js"
export * from "./ImotSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports